import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { filter, Subject, takeUntil } from 'rxjs';

import { ChatRole } from '@app/enums';
import { ChatMessage } from '@app/interfaces';
import { ChatStorageService, LeftNavigationService } from '@craig/core';
import { ChatService } from '../../services/chat/chat.service';

@Component({
    selector: 'craig-dialog-view',
    templateUrl: './dialog-view.component.html',
    styleUrl: './dialog-view.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogViewComponent implements OnInit {
    dialogViewMessages: ChatMessage[] = [];
    responseLoaderShowed: boolean = false;

    @ViewChild('dialogView') dialogViewContainer!: ElementRef;

    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly chatService: ChatService,
        private readonly chatStorageService: ChatStorageService,
        private readonly leftNavigationService: LeftNavigationService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly _window: Window
    ) {}

    ngOnInit(): void {
        this.chatService
            .newMessageChange()
            .pipe(filter(Boolean), takeUntil(this.componentDestroyed$))
            .subscribe((message: ChatMessage) => {
                this.dialogViewMessages.push(message);
                this.changeDetectorRef.detectChanges();
                this.scrollToBottom();
            });

        this.chatService
            .responseLoadingChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((loading: boolean) => {
                this.responseLoaderShowed = loading;

                this.changeDetectorRef.detectChanges();
            });

        this.leftNavigationService
            .chatShowedChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => {
                this.clearDialogView();

                this.changeDetectorRef.detectChanges();
            });

        this.leftNavigationService
            .chatSessionSelectedChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((sessionId: number | null) => {
                if (sessionId !== null) {
                    this.dialogViewMessages = [...this.chatStorageService.getChatMessagesById(sessionId)];
                    this.changeDetectorRef.detectChanges();
                    this.scrollToBottom();
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }

    clearDialogView(): void {
        if (this.dialogViewMessages.length) {
            this.dialogViewMessages = [];
        }
    }

    isAssistantMessage(messageRole: ChatRole): boolean {
        return messageRole === ChatRole.Assistant;
    }

    private scrollToBottom(): void {
        this._window.setTimeout(() => {
            this.dialogViewContainer.nativeElement.scrollTop = this.dialogViewContainer.nativeElement.scrollHeight;
        });
    }
}
